import { ApolloClient } from '@apollo/client';
import { FC, useEffect, useState} from 'react';
import { LifeCycles, registerApplication, start } from 'single-spa';
import { IMenu } from '../model/IMenu';
import AppShell from './Layout/AppShell';
import Emitter from './util/eventEmitter';

const customPropsShared = {
  emitter: Emitter,
  blobUrl: process.env.REACT_APP_URL_BLOB,
  restClient: `${process.env.REACT_APP_SERVICES_DOMAIN}/rest`,
  restLeads: `${process.env.REACT_APP_SERVICES_DOMAIN}/leads`,
  restAutoRed: `${process.env.REACT_APP_SERVICES_DOMAIN}/autored`,
  apiFileUpload: process.env.REACT_APP_FILE_UPLOAD,
  tagManager: process.env.REACT_APP_TAGMANAGER_ID,
  recaptchaKey :  process.env.REACT_APP_RECAPTCHA_KEY
}

const RunRegister: FC<{ client: ApolloClient<any>  , menu:IMenu}> = (props) => {
const [isRegister , setIsRegister] = useState(false)


useEffect(() => {
  if(!isRegister){

    const menuItems = props.menu?.items ?? [];
    
    //todas las paginas incluidas en el menu
    menuItems.forEach((_, index) => {
      registerApplication({
        name: _.spaName,
        app: (): Promise<LifeCycles> => (window as any).System.import(`@single-spa/${_.spaName}`),
        activeWhen: _.url !== "/" ? `${_.url}` : [(location) => location.pathname === _.url],
        customProps: {
          name: _.nombre,
          apolloClient: props.client,
          ...customPropsShared
        },
      });
    } )

    //FOOTER
    registerApplication({
      name:'mf-footer',
      app: (): Promise<LifeCycles> => (window as any).System.import(`@single-spa/derco-parcel-footer`),
      activeWhen:   [(location) => true] ,
      customProps: {
        name: 'mf-footer',
        apolloClient: props.client,
        ...customPropsShared,
        

      },
    });

    setIsRegister(true)

  }
  



  start({
    urlRerouteOnly: true,
  });

}, [isRegister , props.menu.items , props.client])



return (
  <>
    {
      /* El appshell , se encuentra contenido dentro del spin loader ,
       para asi mostrar este por sobre toda la app */
      <AppShell menu={props.menu}/>

    }
  </>
);
}

export default RunRegister;


